import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import POTopBar from './POTopBar';
import OrderDeatilTable from './OrderDetailTabel';
import { checkArray } from '../../../Components/helper';
import CompanyTable from './table/companyTable';
import ShippingDetailTable from './table/ShippingDetailTable';
import SupplierFactoryTable from './table/SupplierFactory';
import CustomSection from './table/CustomSection';
import CompanyDetailsTable from './ForPreviewComponent/CompPreview';
import { usePOTemplateOrderState } from './AddPOTemplateProvider';
import SupplierPreviewTable from './ForPreviewComponent/SupplierPreview';
import ShippingPreviewTable from './ForPreviewComponent/ShippingPreview';
import OrderPreviewTable from './ForPreviewComponent/OrderDetailPreview';
import CustomPreviewTable from './ForPreviewComponent/CustomPreview';

function PODetails({ fromForm }) {
  const { poTemplateState, dropLocation } = usePOTemplateOrderState();

  const templateRendering = (item, i) => {
    switch (item?.key) {
      case 'Company_Details':
        return (
          <Col lg={12}>
            {fromForm ? (
              <CompanyTable element={item} eleIndex={i} dropLocation={dropLocation} fromForm={fromForm} />
            ) : (
              <CompanyDetailsTable element={item} fromForm={fromForm} />
            )}
          </Col>
        );

      case 'order_details':
        return <Col lg={12}>{fromForm ? <OrderDeatilTable index={i} dropLocation={dropLocation} /> : <OrderPreviewTable />}</Col>;

      case 'Shipping_Details':
        return (
          <Col lg={12}>
            {fromForm ? (
              <ShippingDetailTable element={item} eleIndex={i} dropLocation={dropLocation} fromForm={fromForm} />
            ) : (
              <ShippingPreviewTable element={item} fromForm={fromForm} />
            )}
          </Col>
        );
      case 'Supplier_factory':
        return (
          <Col lg={12}>
            {fromForm ? (
              <SupplierFactoryTable element={item} eleIndex={i} dropLocation={dropLocation} fromForm={fromForm} />
            ) : (
              <SupplierPreviewTable element={item} fromForm={fromForm} />
            )}
          </Col>
        );

      default:
        return (
          <Col lg={12}>
            {fromForm ? (
              <CustomSection element={item} eleIndex={i} dropLocation={dropLocation} fromForm={fromForm} />
            ) : (
              <CustomPreviewTable element={item} fromForm={fromForm} />
            )}
          </Col>
        );
    }
  };
  return (
    <Container fluid>
      <POTopBar fromForm={fromForm} />
      <div>
        {checkArray(poTemplateState?.rigthColumn?.templateJsonSchema) &&
          poTemplateState?.rigthColumn?.templateJsonSchema?.map((item, i) => {
            return <Row key={`${item?._id}_rightSection_rows`}>{templateRendering(item, i)}</Row>;
          })}
      </div>
    </Container>
  );
}

export default PODetails;
